import { render, staticRenderFns } from "./FormatNewPagePropertyEditTool.vue?vue&type=template&id=7df981d3&scoped=true&"
import script from "./FormatNewPagePropertyEditTool.vue?vue&type=script&lang=ts&"
export * from "./FormatNewPagePropertyEditTool.vue?vue&type=script&lang=ts&"
import style0 from "./FormatNewPagePropertyEditTool.vue?vue&type=style&index=0&id=7df981d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df981d3",
  null
  
)

export default component.exports